<template>
  <div
    :class="$style['action-icon']"
    :style="`--size: ${size}`"
  >
    <component
      :is="tag"
      :class="{
        [$style['action-icon']]: true,
        [$style['action-icon--disabled']]: isDisabled,
        [$style['action-icon--busy']]: isLoading,
      }"
      :tabindex="tabIndex"
      v-bind="$attrs"
      :disabled="isDisabled || isLoading"
    >
      <slot />
    </component>
  </div>
</template>

<script lang="ts">
import { NuxtLink } from '#components'

export default defineComponent({
  name: 'ActionIcon',
  components: {
    NuxtLink,
  },
  inheritAttrs: false,
  props: {
    tag: {
      type: [String, Object, Function] as PropType<any>,
      required: true,
    },
    size: {
      type: String,
      default: '50px',
    },
    tabIndex: {
      type: String,
      required: false,
      default: undefined,
    },
    isDisabled: {
      type: Boolean,
      require: false,
      default: false,
    },

    isLoading: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
})

</script>

<style lang="postcss" module>
.action-icon {
  width: var(--size);
  height: var(--size);
  background-color: var(--color-mono-100);
  color: var(--color-mono-800);
  box-shadow: var(--shadow-200);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  border: none;
  touch-action: manipulation;
  cursor: pointer;
  pointer-events: all;

  &--disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  &--busy {
    cursor: wait;
  }

  &:focus {
    outline-color: var(--color-primary-700);
  }
}
</style>
